import { Link } from 'gatsby'
import React from 'react'
import PropTypes from 'prop-types'

import './pullquote.css'

const Pullquote = ({ data }) => {
  const config = {
    bgColor: data.config && data.config.bgColor ? data.config.bgColor : 'white',
    textColor: data.config && data.config.textColor ? data.config.textColor : 'black',
    textAlign: data.config && data.config.textAlign ? data.config.textAlign : 'center',
  }
  return (
    <section className={`pullquote bg-${config.bgColor} text-${config.textAlign}`}>
      <div className="content">
        <p className={`text-${config.textColor}`}>{data.text}</p>
        {data.link && data.link.text && (
          <Link to={data.link.url || '#'} className="blockLink">
            {data.link.text}
          </Link>
        )}
      </div>
    </section>
  )
}

Pullquote.propTypes = {
  data: PropTypes.object,
}

Pullquote.defaultProps = {
  data: {
    text: '',
    link: {
      text: '',
      url: '',
    },
    config: {
      textColor: 'black',
      bgColor: 'white',
    },
  },
}

export default Pullquote
